export default __webpack_public_path__ + "static/media/upcoming batch.d5ab1901.png";